// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__tU3Ju"};